"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const CaptionIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M1.5 2.5v11h13.333v-11H1.5zM0 2.208C0 1.541.522 1 1.167 1h14c.644 0 1.166.541 1.166 1.208v11.584c0 .667-.522 1.208-1.166 1.208h-14C.522 15 0 14.459 0 13.792V2.208zm3.5 5.74c0-.5.392-.906.875-.906h4.083c.484 0 .875.405.875.906 0 .5-.391.906-.875.906H4.375c-.483 0-.875-.406-.875-.906zm4.375 2.114c-.483 0-.875.406-.875.907 0 .5.392.906.875.906h4.083c.484 0 .875-.406.875-.906s-.391-.906-.875-.906H7.875zM10.5 7.949c0-.5.392-.906.875-.906h.583c.484 0 .875.405.875.906 0 .5-.391.906-.875.906h-.583c-.483 0-.875-.406-.875-.906zm-6.125 2.114c-.483 0-.875.406-.875.907 0 .5.392.906.875.906h.583c.484 0 .875-.406.875-.906s-.391-.906-.875-.906h-.583z",
    clipRule: "evenodd"
  })))
});
CaptionIcon.displayName = 'CaptionIcon';
var _default = exports.default = CaptionIcon;